import React from "react";
import { Button, Card, Col, Image, Modal, Row } from "react-bootstrap";
import partnerHeader from "../assets/images/partner/partner-header.png";
import employeeLoanImg from "../assets/images/products/employee-loan.png";
import poFinancingImg from "../assets/images/products/po-financing.png";
import lenderLoginImg from "../assets/images/lender-login.png";
import elefinLogo from "../assets/images/elefin-black.png";
import { ENV } from "../config/env";
import { PRODUCTS } from "../constants/products";
import { useDispatch } from "react-redux";
import { setForm } from "../reducers/formslice";
import { useSelector } from "react-redux";
import { RootState } from "../reducers";
import { ELEFIN_HOME } from "../constants";

function LoginModal() {
  const dispatch = useDispatch();
  const { form } = useSelector((state: RootState) => state.form);
  const handleLogin = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    window.open(ENV.POHON_DANA_URL + "/login", "_blank");
  };
  const handleLoginHr = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    window.open(ENV.USER_PORTAL, "_blank");
  };
  const handleLoginEmployee = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    window.open(ENV.EMPLOYEE_LOAN, "_blank");
  };
  const handleLoginUserPortal = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    window.open(ENV.USER_PORTAL, "_blank");
  };
  const handleRegister = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    dispatch(setForm("register"));
  };

  return (
    <React.Fragment>
      <Modal
        size="xl"
        show={form === "login"}
        onHide={() => {
          dispatch(setForm(null));
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center">
            Pilih jenis akun anda
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="justify-content-center">
            <Col xl={4} lg={6} md={6} sm={12} className="p-2">
              <Card className={`h-100 card-hover`}>
                <Card.Body className="p-0">
                  <div className="d-flex h-100 justify-content-between flex-column gap-2">
                    <div className="px-4 pt-4 fw-bold text-size-body-head-2 text-primary-main">
                      {PRODUCTS.poFinancing.title}
                    </div>
                    <div className="d-flex d-md-block d-lg-flex justify-content-between">
                      <div
                        className="px-4 pb-4 d-flex flex-column"
                        style={{ flex: 1 }}
                      >
                        <div className="text-size-caption" style={{ flex: 1 }}>
                          Belanja dari premium partner
                        </div>
                        <div className="mb-4">
                          <a
                            href={ELEFIN_HOME}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <Image
                              src={elefinLogo}
                              fluid
                              width={100}
                              alt="Elefin"
                            />
                          </a>
                        </div>
                        <div className="mt-2 mb-0">
                          <Button variant="primary" onClick={handleLogin}>
                            Masuk Pohon Dana
                          </Button>
                        </div>
                      </div>
                      <div className="align-self-end d-block d-md-none d-lg-block">
                        <Image src={poFinancingImg} fluid width={80} />
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col xl={4} lg={6} md={6} sm={12} className="p-2">
              <Card className={`h-100 card-hover`}>
                <Card.Body className="p-0">
                  <div className="d-flex h-100 justify-content-between flex-column gap-2">
                    <div className="px-4 pt-4 fw-bold text-size-body-head-2 text-primary-main">
                      Business Loan
                    </div>
                    <div className="d-flex d-md-block d-lg-flex justify-content-between gap-2">
                      <div className="px-4 pb-4" style={{ flex: 1 }}>
                        {(ENV.V2_PRODUCTS.includes("capitalLoan") &&
                          ENV.V2_PRODUCTS.includes("invoiceFinancing")) ||
                        (!ENV.V2_PRODUCTS.includes("capitalLoan") &&
                          !ENV.V2_PRODUCTS.includes("invoiceFinancing")) ? (
                          <React.Fragment>
                            <div className="text-size-caption">
                              untuk produk:
                            </div>
                            <div className="text-size-caption">
                              - {PRODUCTS.capitalLoan.title}
                            </div>
                            <div className="text-size-caption mb-4">
                              - {PRODUCTS.invoiceFinancing.title}
                            </div>
                            <div className="mt-2 mb-0">
                              <Button
                                variant="primary"
                                onClick={
                                  ENV.V2_PRODUCTS.includes("capitalLoan") &&
                                  ENV.V2_PRODUCTS.includes("invoiceFinancing")
                                    ? handleLoginUserPortal
                                    : handleLogin
                                }
                              >
                                Masuk
                              </Button>
                            </div>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <div className="text-size-caption">
                              {PRODUCTS.capitalLoan.title}
                            </div>
                            <div className="mt-2 mb-0">
                              {ENV.V2_PRODUCTS.includes("capitalLoan") ? (
                                <Button
                                  variant="primary"
                                  onClick={handleLoginUserPortal}
                                >
                                  Masuk
                                </Button>
                              ) : (
                                <Button variant="primary" onClick={handleLogin}>
                                  Masuk
                                </Button>
                              )}
                            </div>
                            <hr className="my-2" />
                            <div className="text-size-caption">
                              {PRODUCTS.invoiceFinancing.title}
                            </div>
                            <div className="mt-2 mb-0">
                              {ENV.V2_PRODUCTS.includes("invoiceFinancing") ? (
                                <Button
                                  variant="primary"
                                  onClick={handleLoginUserPortal}
                                >
                                  Masuk
                                </Button>
                              ) : (
                                <Button variant="primary" onClick={handleLogin}>
                                  Masuk
                                </Button>
                              )}
                            </div>
                          </React.Fragment>
                        )}
                      </div>
                      <div className="align-self-end d-block d-md-none d-lg-block">
                        <Image src={partnerHeader} fluid width={80} />
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col xl={4} lg={6} md={12} sm={12} className="p-2">
              <Card className={`h-100 card-hover`}>
                <Card.Body className="p-0">
                  <div className="d-flex h-100 justify-content-between flex-column gap-2">
                    <div className="px-4 pt-4 fw-bold text-size-body-head-2 text-primary-main">
                      {PRODUCTS.employeeLoan.title}
                    </div>
                    <div className="d-flex justify-content-between gap-4">
                      <div className="px-4 pb-4" style={{ flex: 1 }}>
                        <div className="text-size-caption">
                          Karyawan / peminjam
                        </div>
                        <div className="mt-2 mb-0">
                          <Button
                            variant="primary"
                            onClick={handleLoginEmployee}
                          >
                            Masuk
                          </Button>
                        </div>
                        <hr className="my-2" />
                        <div className="text-size-caption">
                          Bagian personalia / HR
                        </div>
                        <div className="mt-2 mb-0">
                          <Button
                            variant="outline-primary"
                            onClick={handleLoginHr}
                          >
                            Masuk
                          </Button>
                        </div>
                      </div>
                      <div className="align-self-end">
                        <Image src={employeeLoanImg} fluid width={80} />
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <div className="mt-5 text-center text-size-sub-body-2">
            Belum punya akun?{" "}
            <a href={"/"} rel="noreferrer" onClick={handleRegister}>
              Daftar di sini
            </a>
          </div>
          <hr />
          <Row className="justify-content-center">
            <Col xl="auto" lg="auto" md={12} sm={12} className="p-2">
              <Card className={`h-100 card-hover`}>
                <Card.Body className="p-0">
                  <div className="d-flex h-100 justify-content-between gap-2">
                    <div className="p-4">
                      <div className="fw-bold text-size-caption text-primary-main">
                        Pendana / Pemberi Pinjaman
                      </div>
                      <div className="mt-2 mb-0">
                        <Button
                          size="sm"
                          variant="primary"
                          onClick={() => {
                            window.open(
                              ENV.POHON_DANA_URL + "/login",
                              "_blank"
                            );
                          }}
                        >
                          Masuk
                        </Button>
                      </div>
                    </div>
                    <div className="align-self-end">
                      <Image src={lenderLoginImg} fluid width={80} />
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}

export default LoginModal;
